import { AppLocation } from './AppLocationContext';

export const getDeepestLocation = (locations: AppLocation[]): AppLocation => {
  const result = locations.reduce((currentLocation, location) => {
    if (currentLocation) {
      const currentLocationLength = currentLocation.path
        ? currentLocation.path.split('.').length
        : 0;
      const locationLength = location.path ? location.path.split('.').length : 0;

      if (currentLocationLength > locationLength) {
        return currentLocation;
      }

      if (locationLength > currentLocationLength) {
        return location;
      }

      // If a new location was added because of fast navigation, it should be the current one
      if (location.path) {
        return location;
      }
    }

    return location;
  }, undefined as AppLocation);

  return result;
};
